import { ImageLoaderConfig, IMAGE_LOADER } from '@angular/common';
import { Provider } from '@angular/core';
import { formatVariant, parseFilename } from '@tanzspass/shared';
import { TsHttpService } from '../../services/ts-http.service';

export function tsImageLoader(config: ImageLoaderConfig): string {
  const base = TsHttpService.assetsRoot ?? '';
  const parsed = parseFilename(config.src);

  if (!parsed) {
    return base + config.src;
  }

  if (!config.width) {
    return base + config.src;
  }

  return (
    base +
    formatVariant({
      id: parsed.id,
      width: parsed.width,
      height: parsed.height,
      variantWidth: config.width,
    })
  );
}

export const tsImageLoaderProvider: Provider = {
  provide: IMAGE_LOADER,
  useValue: tsImageLoader,
};
